<script setup>
import EmailingAutomationForm from '@frontJs/components/forms/projectManagement/modules/EmailingAutomationForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const {
    tenant,
    emailingAutomation,
    emailingAutomationTypes,
    emailingAutomationCustomerTypes,
    orderStatuses,
    promoPriceRules,
} = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
    emailingAutomation: {
        type: Object,
        required: false,
    },
    emailingAutomationTypes: {
        type: Array,
        required: true,
    },
    emailingAutomationCustomerTypes: {
        type: Array,
        required: true,
    },
    orderStatuses: {
        type: Array,
        required: true,
    },
    promoPriceRules: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="emailingAutomation">
            Mettre à jour l'emailing automatisé #{{ emailingAutomation.id }} -
            Emailings automatisés Modules - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un emailing automatisé - Emailings automatisés - Modules -
            Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="emailingAutomation" :tenant-name="tenant.name">
        Gestion de projet - Modules - Emailings automatisés - Mettre à jour
        l'emailing automatisé #{{ emailingAutomation.id }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - Modules - Emailings automatisés - Créer un emailing
        automatisé
    </PageTitle>

    <EmailingAutomationForm
        :emailing-automation="emailingAutomation"
        :emailing-automation-types="emailingAutomationTypes"
        :emailing-automation-customer-types="emailingAutomationCustomerTypes"
        :tenant="tenant"
        :order-statuses="orderStatuses"
        :promo-price-rules="promoPriceRules"
    />
</template>
